module.exports = __webpack_public_path__ + "images/emoji/pencil.4f4df2be4d4eb283b640.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pencil.png
// module id = hYuX
// module chunks = 14